export default function populateEftPaymentOption(option, data) {
  if (typeof data.token !== 'undefined') {
    option.token = data.token; // eslint-disable-line no-param-reassign
  }

  if (data.updateOption) {
    option.details.accountNumber = data.updateOption.accountNumber; // eslint-disable-line no-param-reassign
    option.details.accountType = data.updateOption.accountType; // eslint-disable-line no-param-reassign
    option.details.institutionNumber = data.updateOption.institutionNumber; // eslint-disable-line no-param-reassign
    option.details.branchNumber = data.updateOption.branchNumber; // eslint-disable-line no-param-reassign
    option.details.firstName = data.updateOption.firstName; // eslint-disable-line no-param-reassign
    option.details.lastName = data.updateOption.lastName; // eslint-disable-line no-param-reassign
  }

  return option;
}
